import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { StickyCTA } from "@/components/CTA";
import Home from "@/pages/Home";
import ComoFunciona from "@/pages/ComoFunciona";
import Servicio from "@/pages/Servicio";
import ParaComercios from "@/pages/ParaComercios";
import FAQ from "@/pages/FAQ";
import Alta from "@/pages/Alta";
import Exito from "@/pages/Exito";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <div className="grain min-h-screen bg-night text-offwhite">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/servicio" element={<Servicio />} />
            <Route path="/para-comercios" element={<ParaComercios />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/alta" element={<Alta />} />
            <Route path="/alta/exito" element={<Exito />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <StickyCTA />
        </div>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
